/**
 * Code is taken directly from keycloak-js library to decode a token.
 * For example idToken -> idTokenParsed
 *
 * https://github.com/keycloak/keycloak-js/blob/52c8ad8f2e75123dfd1c5a4f6ef6c76ce2fd9be4/lib/keycloak.js#L1802
 */
/**
* @param {string} input
*/
function b64DecodeUnicode(input) {
    return decodeURIComponent(atob(input).replace(/(.)/g, (m, p) => {
        let code = p.charCodeAt(0).toString(16).toUpperCase();
        if (code.length < 2) {
            code = `0${code}`;
        }
        return `%${code}`;
    }));
}
/**
   * @param {string} input
   */
function base64UrlDecode(input) {
    let output = input
        .replaceAll('-', '+')
        .replaceAll('_', '/');
    switch (output.length % 4) {
        case 0:
            break;
        case 2:
            output += '==';
            break;
        case 3:
            output += '=';
            break;
        default:
            throw new Error('Input is not of the correct length.');
    }
    try {
        return b64DecodeUnicode(output);
    }
    catch (_a) {
        return atob(output);
    }
}
/**
  * @param {string} token
  */
export function decodeToken(token) {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars, no-unused-vars
    const [headers, payload] = token.split('.');
    if (typeof payload !== 'string') {
        throw new Error('Unable to decode token, payload not found.');
    }
    let decoded;
    try {
        decoded = base64UrlDecode(payload);
    }
    catch (error) {
        throw new Error('Unable to decode token, payload is not a valid Base64URL value.', { cause: error });
    }
    try {
        return JSON.parse(decoded);
    }
    catch (error) {
        throw new Error('Unable to decode token, payload is not a valid JSON value.', { cause: error });
    }
}
export default decodeToken;
